<template>
  <q-layout view="hHh lpR fFf" style="height:100vh;">
    <q-header class="bg-black text-white" reveal elevated>
      <q-toolbar class="q-pa-sm">
        <q-toolbar-title>
          <div class="row justify-between">
            <div class="">
              <img src="/img/Logo_Original_Blanc_100px.png" class="q-pt-sm" />
            </div>
            <div class="q-pt-md text-uppercase text-subtitle1 text-center text-weight-bold">
              session bar : {{seance.code_acces}}
            </div>
          </div>
        </q-toolbar-title>
      </q-toolbar>
    </q-header>
    <q-page-container>
      
        <!--
        <q-input 
          v-model="lookedForDrink" standout="bg-dark-grey" rounded bg-color="dark-grey" color="dark-grey-clear" class="q-pa-md" label-slot>
           <template v-slot:label>

             <p class="text-dark-grey-clear">Rechercher une boisson</p>
          </template>
          <template v-slot:append>
            <q-icon name="search" size="2em" color="dark-grey-clear"/>
          </template>
        </q-input>
        -->
        <router-view/>
    </q-page-container>
    <q-page-sticky
            :class="startKrack ? 'footer-toolbar bg-krach': 'footer-toolbar'"
            expand
            position="bottom"
          >
            <marquee
              v-if="actus"
              :duration="50"
              :repeat="10"
              :paused="true"
            >
              <div class="marquee-content" v-for="actu in actus" :key="actu.id">
                <div class="flex no-wrap">
                  <span v-html=actu.content></span>
                  <q-icon v-if="actu.icon" class="q-pl-sm" :name="actu.icon" :color="actu.iconColor" size="sm"/>
                </div>
              </div>
            </marquee>
          </q-page-sticky>
  </q-layout>
</template>

<script>

import ReconnectingEventSource from "reconnecting-eventsource";
import { getAllDrinksAnonymousByCatBySeance, getPriceHistoriesAnonymousBySeance } from '~/services/drinks';
import { getAnonymousSeanceById, getNewsBySession } from '~/services/seances';
import { baseUrl, base_url_seances } from '~/variables';
import CategoryMobile from '../components/CategoryMobile.vue';
import DrinkMobile from '../components/DrinkMobile.vue';

export default {
  name: "mobileDrinks",
  components: {
    CategoryMobile,
    DrinkMobile
  },
  data() {
    return {
      actus: [],
      clock: {
        time: ''
      },
      isPaused: false,
      categories: [],
      colors: ['text-green-4', 'text-pink-4', 'text-light-blue-4', 'text-yellow-4', 'text-orange-4', 'text-red-4'],
      idSeance: null,
      showKrackDialog: false,
      startKrack: false,
      timesCategories: [],
      series: [],
      seance:{},
      es: null,
      lookedForDrink: ""
    };
  },  
  async created() {
    this.idSeance = this.$route.params.idSeance;
    let response = await getAnonymousSeanceById(this.idSeance);
    if (response.status == 200) {
      this.seance = response.data;
    }
    response = await getAllDrinksAnonymousByCatBySeance(this.idSeance);
    if (response.status === 200) {
      this.categories = response.data.map(ctg => { 
        ctg.drinks = ctg.drinks.map(e => {
          return {...e, difference: 0.00} 
        })
        return ctg
      });
    } 

    response = await getNewsBySession(this.idSeance)
    if (response.status === 200) {
      this.actus = response.data
    }
    /*
    
    }*/
  },
  mounted() {
    this.setupStreams();
  },
  destroyed () {
    this.closeStreams()
  },
  methods: {
    setupStreams() {
      this.esCurrentSession = new ReconnectingEventSource(`${baseUrl}${base_url_seances}/${this.idSeance}/events/`)
      this.esGeneric = new ReconnectingEventSource(`${baseUrl}${base_url_seances}/events/`)

      this.addSessionListeners()
      this.addNewsListeners()
    },
    closeStreams() {
      this.esCurrentSession.close()
      this.esGeneric.close()
    },
    addSessionListeners() {
      this.esCurrentSession.addEventListener('command', event => {
        let data = JSON.parse(event.data)
        const prices = data.consommation_set.map(e => e.price * e.quantite)
        let price = prices.reduce((accumulator, currentValue) => accumulator + currentValue)
        price = Number.parseFloat(price).toFixed(2)
        this.$q.notify({
          color: 'green-4',
          textColor: 'white',
          icon: 'fas fa-check-circle',
          message: `Nouvelle commande: ${price} € `,
          position: 'top-right',
        })
      }, false)
      this.esCurrentSession.addEventListener('update', event => {
        const data = JSON.parse(event.data)
        data.map( priceHistory => {
          for (const category of this.categories) {
            const index = category.drinks.findIndex(drink => drink.id === priceHistory.drink.id)
            if (index !== -1) {
              const oldPrice = category.drinks[index].current_price
              const difference = (((priceHistory.price / oldPrice) * 100) - 100)
              this.$set(category.drinks, index , {...priceHistory.drink, difference})
              break
            }
          }
        })
      }, false)
      this.esCurrentSession.addEventListener('krach_start', event => {
        this.startKrack = true
        this.toggleKrackDialog()
        setTimeout(() => this.toggleKrackDialog(), 4000)
      }, false)
      this.esCurrentSession.addEventListener('krach_stop', event => {
        this.startKrack = false
        this.toggleKrackDialog()
        setTimeout(() => this.toggleKrackDialog(), 4000)
      }, false)
    },
    addNewsListeners() {
      this.esCurrentSession.addEventListener('deleteNews', event => {
        const data = JSON.parse(event.data)
        this.deleteNews(data)
      })
      this.esCurrentSession.addEventListener('updateNews', event => {
        const data = JSON.parse(event.data)
        this.updateNews(data)
      })
      this.esCurrentSession.addEventListener('createNews', event => {
        const data = JSON.parse(event.data)
        this.updateNews(data)
      })
      this.esGeneric.addEventListener('deleteNews', event => {
        const data = JSON.parse(event.data)
        this.deleteNews(data)
      })
      this.esGeneric.addEventListener('updateNews', event => {
        const data = JSON.parse(event.data)
        this.updateNews(data)
      })
      this.esGeneric.addEventListener('createNews', event => {
        const data = JSON.parse(event.data)
        this.updateNews(data)
      })
    },
    setupStream() {
      // Not a real URL, just using for demo purposes
      this.es = new ReconnectingEventSource(`${baseUrl}${base_url_seances}/${this.idSeance}/events/`);

      this.es.addEventListener('command', event => {
        let data = JSON.parse(event.data);
        const prices = data.consommation_set.map(e => e.price * e.quantite)
        let price = prices.reduce((accumulator, currentValue) => accumulator + currentValue);
        price = Number.parseFloat(price).toFixed(2);
        this.$q.notify({
          color: 'green-4',
          textColor: 'white',
          icon: 'fas fa-check-circle',
          message: `Nouvelle commande: ${price} € `,
          position: 'top-right',
        });
      }, false);
      this.es.addEventListener('update', event => {
        let data = JSON.parse(event.data);
        data.map( e => {
          // Récupération de l'index de la boisson qu'on va traiter
          var catI = 0;
          var drinkI = 0;
          var found = false
          for (const cat of this.categories) {
            drinkI=0;
            for (const drink of cat.drinks) {
              if (drink.id === e.drink.id) {
                found = true;
                break;
              }
              drinkI+=1;
            }
            if (found) {
              break
            }
            catI+=1;
          }
          // Récupération de l'ancien prix
          const old_price = this.categories[catI].drinks[drinkI].current_price;
          //Calcul de la différence en pourcentage
          const difference = (((e.price / old_price) * 100) - 100)
          // Forcage de la réactivité
          this.$set(this.categories[catI].drinks, drinkI , {...e.drink, difference})
          /*
          const index2 = this.series.findIndex(e1 => e1.name === e.drink.name);
          let serie = this.series[index2].data;
          let tempSeries = [...this.series];
          tempSeries[index2].data.push([e.time, e.price])
          // On enlève les éléments dont la date est plus grande que 30 minutes
          tempSeries[index2].data = tempSeries[index2].data.filter(el => new Date(el[0]) > new Date(Date.now() - 1000 * 60 * 40))
          this.series = [...tempSeries];*/
        });
      }, false);
      this.es.addEventListener('krach_start', event => {
        this.startKrack = true;
        this.toggleKrackDialog();
        setTimeout(() => this.toggleKrackDialog(), 2500)
      }, false);
      this.es.addEventListener('krach_stop', event => {
        this.startKrack = false;
        this.toggleKrackDialog();
        setTimeout(() => this.toggleKrackDialog(), 2500)
      }, false);
    },
    toggleKrackDialog() {
      this.showKrackDialog = !this.showKrackDialog;
    },
    updateNews(data) {
      this.actus = this.actus.map(actu => {
        if (actu.id === data.id) {
          return data
        }
        return actu
      })

      if (!this.actus.find(actu => actu.id === data.id)) {
        this.addNews(data)
      }
    },
    deleteNews(data) {
      this.actus = this.actus.filter(actu => actu.id !== data.id)
    },
    addNews(data) {
      this.actus.push(data)
    }
  },
}
</script>
<style lang="scss" scoped>
.q-layout{
  font-family: 'Montserrat';
}
.q-header, .footer-toolbar{
  border-style: solid;
  border-width: 2px;
  border-image: linear-gradient(to left, rgba(0, 0, 0, 1) 1%, #7B7B7B 50%, rgba(0, 0, 0, 1) 100%) 
                100% 0 100% 0/2px 0 2px 0 stretch;
}
.trading-content{
  height: 80vh;
  background:  
  url("../../public/svg/Vector 1.svg") left/auto 30% no-repeat, 
  url("../../public/svg/Vector 2.svg") right/auto 30% no-repeat;
}
.footer-toolbar{
  padding-top: 5px;
  padding-bottom: 0px;
  color: #ffffff;
  background-color: #000000;
}
.marquee-content{
  display: inline-block;
  padding: 10px 20px 0px 20px;
  border-right: 1px solid #676767;
}
.responsive-top-margin{
  @media screen and (min-width:  1023px) {
    margin-top: 10vh;
  }
}

</style>